import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ProofOfDebtRemark } from '../../interfaces/proofOfDebtRemark';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileUploadComponent } from '../../file/fileUpload/file-upload/file-upload.component';
import { CreditorRemarkService } from './creditor-remark.service';
import { ErrorModalService } from '../../modal/error.modal.service';
import { ProofOfDebtRemarkMessage } from '../../interfaces/proofOfDebtRemarkMessage';

@Component({
    selector: 'creditor-remark',
    templateUrl: './creditor-remark.component.html',
    styleUrls: ['./creditor-remark.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreditorRemarkComponent {

  constructor(
    protected service: CreditorRemarkService,
    protected errorModalService: ErrorModalService,
    protected spinner: NgxSpinnerService,
    protected fb: FormBuilder
  ) { }

  @Input() remark: ProofOfDebtRemark;
  @Input() caseId: string;
  @Input() creditorId: string;

  public userForm: FormGroup;
  public get messageMaxLength(): number { return 6000 };

  public get messageForm() { return this.userForm.get('message') };
  public get message() { return this.messageForm.value; }
  public set message(value: string) { this.messageForm.setValue(value); }
  public get antalMeddelandenSomVisas(): number { return 4 };
  public visaAllaMeddelanden: boolean = false;

  public isSubmitting: boolean = false;

  @ViewChild(FileUploadComponent) fileUpload!: FileUploadComponent;
  public get files() { return this.fileUpload?.files ?? []; }

  public ngOnInit(): void {
    const approvedControl = new FormControl(this.remark?.isApproved ? 'true' : null, Validators.required);
    if (this.remark?.isApproved)
      approvedControl.disable();

    this.userForm = this.fb.group({
      'message': new FormControl('', Validators.maxLength(this.messageMaxLength)),
      'approved': approvedControl
    });
  }

  public createMessage(): void {
    if (this.isSubmitting)
      return;

    this.isSubmitting = true;
    this.spinner.show();
    const id = this.remark.claimId;
    const caseId = this.caseId;
    const message = this.message;
    const files = this.files;
    const isApproving = this.userForm.get('approved').value === 'true';

    this.service.sendResponse(id, caseId, message, files, isApproving, this.creditorId).subscribe(
      (newMessages: ProofOfDebtRemarkMessage[]) => {
        if (isApproving) {
          this.remark.isApproved = true;
          this.userForm.get('approved').disable();
        }

        this.remark.messages = [
          ...(this.remark.messages ?? []),
          ...(newMessages ?? []).map(newMessage => ({
            message: newMessage.message,
            createdBy: newMessage.createdBy,
            createdUtc: newMessage.createdUtc,
            files: newMessage.files,
            isFromGk: newMessage.isFromGk,
            createdByInitials: newMessage.createdByInitials
          }))
        ];

        this.message = '';
        this.isSubmitting = false;
        this.spinner.hide();
        this.fileUpload.clear();
      },
      (error) => {
        this.errorModalService.open('Inläsningsfel', 'Misslyckades att skicka svar');
        this.isSubmitting = false;
        this.spinner.hide();
      });
  }
}
